import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import AnalyticsTooltip from "src/components/Referral-partner/Analytics/AnalyticsTooltip";
import { TimeSeriesDataPoint } from "src/components/Referral-partner/Analytics/analyticsTypes";
import {
  AXIS_STYLES,
  GRID_STYLES,
  ReferralFeedTitle,
  ReferralFeesDragWrapper,
  ReferralFeesWrapper,
  ReferralFessText,
  RefferalFeesHeading,
} from "src/components/Referral-partner/Analytics/styles/chart.styles";
import RightArrowIcon from "src/icons/portfolio/RightArrowIcon";

interface CustomerGrowthProps {
  title?: string;
  data: TimeSeriesDataPoint[];
  totalFees: string;
}

const ReferralFees = (props: CustomerGrowthProps) => {
  const { title, data, totalFees } = props;

  return (
    <ReferralFeesWrapper id="referral-fees-chart">
      <ReferralFeesDragWrapper className="drag-handle">
        {/* BALANCE HEADING */}
        <RefferalFeesHeading>
          <ReferralFeedTitle onClick={() => {}}>
            {title}
            <RightArrowIcon />
          </ReferralFeedTitle>
          <ReferralFessText id="user-balance-amount">{totalFees} USDC</ReferralFessText>
        </RefferalFeesHeading>
      </ReferralFeesDragWrapper>

      {/* CHART */}
      <ResponsiveContainer>
        <AreaChart data={data} margin={{ top: 20, left: -15, right: 0 }}>
          <defs>
            <linearGradient id="colorUsers" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#e66d79" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#e66d79" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid vertical={false} {...GRID_STYLES} />
          <XAxis dataKey="timestamp" {...AXIS_STYLES} />
          <YAxis {...AXIS_STYLES} />
          <Tooltip content={<AnalyticsTooltip />} />
          <Area
            type="monotone"
            dataKey="fees"
            fill="url(#colorUsers)"
            stroke="#e66d79"
            strokeWidth={0.5}
          />
        </AreaChart>
      </ResponsiveContainer>
    </ReferralFeesWrapper>
  );
};

export default ReferralFees;
